import { Link } from "@tanstack/solid-router";
import type { ParentComponent } from "solid-js";

const NotFound: ParentComponent = (props) => (
	<div class="space-y-2 p-2">
		<div class="text-gray-600 dark:text-gray-400">
			{props.children ?? <p>The page you are looking for does not exist.</p>}
		</div>

		<p class="flex flex-wrap items-center gap-2">
			<button
				onClick={() => {
					globalThis.history.back();
				}}
			>
				Go back
			</button>

			<Link to="/">Start Over</Link>
		</p>
	</div>
);

export { NotFound };
